<template>
  <div class="bg-white relative overflow-hidden">
    <div
      class="flex align-center justify-between flex-end">
      <span class="mt-4 ml-4" id="regional">
        {{ viewName }}
      </span>
      <slot>
        &nbsp;
      </slot>
    </div>
    <div>
      <SmartP class="ml-3">
        {{ returnSigles }}
      </SmartP>
    </div>
    <div class="flex align-center space mb-4">
      <div class="flex flex-col">
        <p class="text-brand-secondary ml-4">
          Status atual
        </p>
        <p class="ml-4">
          {{ status }}
        </p>
      </div>
    </div>
    <div class="absolute card__icon">
      <SmartIcon
        type="big"
        :name="viewName"
        style="width:310px;height:100%;"
      />
    </div>
  </div>
</template>

<script>
// @flow
export default {
  name: 'SmartCardView',
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    isSendReminder: {
      type: Boolean,
      default: true
    },
    viewName: {
      type: String
    },
    stateSigles: {
      type: Array,
      default: () => []
    },
    status: {
      type: String
    }
  },
  computed: {
    returnSigles() {
      return this.stateSigles
      && this.stateSigles.join(', ').replace(/, ([^,]*)$/, ' e $1');
    }
  },
  methods: {
    reminde() {
      // aqui irá ter o comando de envio de email para a regional
    },
    resolve() {
      this.$router.push({ name: 'GoalsValidation' });
    },
    async publishGoal() {
      this.isLoading = true;
      await this.$emit('publishGoal');
      // this.isLoading = false;
    }
  }
};
</script>

<style scoped lang="scss">

.card {
  max-width: 480px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  &__icon {
    right: - $spacing-margin-xxsmall;
    bottom: - $spacing-margin-xxsmall;
  }
}

.space {
  margin-top: 45px;
}

.secao {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 24px;
}

#regional {
  font-size: 48px;
  font-weight: 500;
}
</style>
